import { useQuery } from "react-query";
import { getActiveNoEmployeeId } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetActiveNoEmployeeId = () => {
  return useQuery("GetActiveNoEmployeeId", getActiveNoEmployeeId, {
    refetchOnWindowFocus: false,
  });
};
export default useGetActiveNoEmployeeId;
